// APP
export const APP_STATUS = {
  INSTALLED: 'Installed',
  WAITING_ON_PIPE: 'Waiting On Pipe',
  ON_PIPE: 'On Pipe',
  HIGH_USAGE: 'High Usage',
  LEAK_INACTIVE: 'Leak Inactive',
  LEAK_ACTIVE: 'Leak Active',
  LOW_SIGNAL: 'Low Signal',
  NO_SIGNAL: 'No Signal',
  ENGINEER_REPAIRED: 'EngineerLeakRepaired',
  CUST_REPAIRED: 'Cust Repaired',
  ENG_VISIT: 'Eng Visit',
  ENG_VISIT_NO_LEAK: 'Eng Visit No Leak',
  FITTING_ERROR: 'FittingError7'
}

// LEAK
export const LEAK_STATUS = {
  NULL: 'null',
  LEAK: 'Leak',
  NO_LEAK: 'No Leak',
  ENG_VISIT_NO_LEAK: 'No Leak - Eng Visit',
  LEAK_ENG_VISIT: 'Leak - Eng Visit Booked',
  REPAIRED: 'Eng Repaired',
  CUST_REPAIRED: 'Cust Repaired',
  CUST_REPAIRED_FAILED: 'Leak - Cust Repair Failed',
  FAILED_REPAIR: 'Leak - Eng Repair Failed',
  UNKNOWN_NO_SIG: 'Unknown - No Signal',
  UNKNOWN_LOST_SIG: 'Unknown - Lost Signal',
  UNKOWN: 'Unknown',
  SUSPECT: 'Suspect'
}

// CONNECTIVITY
export const CONNECTIVITY_STATUS = {
  NULL: 'null',
  NO_SIGNAL: 'NoSignal',
  HAS_SIGNAL: 'HasSignal',
  LOW_SIGNAL: 'LowSignal',
  LOST_SIGNAL: 'LostSignal'
}

// BATTERY
export const BATTERY_STATUS = {
  NULL: 'null',
  GOOD_BATTERY: 'GoodBattery',
  LOW_BATTERY: 'LowBattery',
  NO_BATTERY: 'NoBattery',
  NO_SIGNAL: 'Battery - No Signal'
}

// ANALYSING MODE
export const ANALYSING_STATUS = {
  HIGH_USAGE_ONLY: 'High Usage Only'
}

// ONBOARDING
export const ONBOARDING_EVENTS = {
  ON_PIPE: 'OnPipe',
  WAITING_ON_PIPE: 'WaitingOnPipe',
  LEAK_TRUE: 'LeakTrue',
  LEAK_FALSE: 'LeakFalse',
  REGISTERED: 'Registered'
}

export const ONBOARDING_STATUS = {
  PAIRED: 'Paired with account',
  AWAITING_TAP: 'Awaiting tap on events',
  AWAITING_LEAK: 'Awaiting Leak test',
  COMPLETE: 'Complete'
}
